<div #resultsContainer class="result-container resizable-table" [ngClass]="{ 'archive-mode': isArchiveMode }" (scroll)="onScroll($event)">
    @if (loadedFoldersCount > 0) {
        <form novalidate>
            <table
                #resultsTable
                id="resultsTable"
                mat-table
                class="result-table"
                [class]="tableClass"
                [dataSource]="tableDataSource"
                [trackBy]="trackFolder"
                multiTemplateDataRows
                matSort
                (matSortChange)="sortFolders($event)"
                [matSortActive]="currentSort.active"
                [matSortDirection]="currentSort.direction"
                cdkDropList
                (cdkDropListDropped)="onDrop($event)"
                [cdkDropListSortingDisabled]="true"
                [ngClass]="{ 'horizontal-scrolling': _internalConfiguration.listLayout.isLayoutMustFitScreenSize === false }">
                @if (_internalConfiguration.listLayout.isLayoutMustFitScreenSize) {
                    @for (column of displayedColumnsDefinitions; track column.propertyCode; let i = $index) {
                        <ng-container [matColumnDef]="column.propertyCode">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                [style.width.%]="column.size"
                                appColumnResize
                                (resizing)="onColumnResizing(column, $event)"
                                (resized)="onColumnResized(column)">
                                <app-table-header-cell [column]="column"></app-table-header-cell>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                [style.min-width.%]="column.size"
                                [style.max-width.%]="column.size"
                                [style.width.%]="column.size"
                                (contextmenu)="copyTextIntoClipboard($event)">
                                @if (column.type === PropertyType.Workflow) {
                                    <app-table-workflow-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [isWorkflowStepDateVisible]="isWorkflowStepDateVisible"
                                        [row]="row"></app-table-workflow-cell>
                                } @else {
                                    <app-table-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [row]="row"
                                        [isExpanded]="row.expanded"
                                        [isExpandCommentsMode]="expandComments === true"
                                        (expandOrCollapseRow)="expandOrCollapseRow($event)"></app-table-cell>
                                }
                            </td>
                        </ng-container>
                    }
                    <ng-container [matColumnDef]="actionColumnDefinition.propertyCode" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef [style.min-width.%]="3" [style.max-width.%]="3" [style.width.%]="3" class="action-header">
                            <div class="action-header-text">{{ actionColumnDefinition.header }}</div>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let row; let index = dataIndex"
                            class="action-column"
                            [style.min-width.%]="3"
                            [style.max-width.%]="3"
                            [style.width.%]="3"
                            class="action-cell">
                            <app-table-action-cell
                                [actionColumnDefinition]="actionColumnDefinition"
                                [row]="row"
                                [view]="viewsStateService.getSelectedView()"
                                [index]="index"
                                (contextualMenuOpen)="onContextualMenuOpen($event)"
                                (contextualMenuSelect)="onContextualMenuSelect($event)"></app-table-action-cell>
                        </td>
                    </ng-container>
                }
                @if (!_internalConfiguration.listLayout.isLayoutMustFitScreenSize) {
                    @for (column of stickyColumnsDefinition; track column.propertyCode; let i = $index; let last = $last) {
                        <ng-container [matColumnDef]="column.propertyCode" sticky>
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                [style.min-width.px]="column.size"
                                [style.max-width.px]="column.size"
                                [style.width.px]="column.size"
                                class="sticky"
                                [class.last-sticky]="last"
                                appColumnResize
                                (resizing)="onColumnResizing(column, $event)"
                                (resized)="onColumnResized(column)">
                                <app-table-header-cell [column]="column"></app-table-header-cell>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                [style.min-width.px]="column.size"
                                [style.max-width.px]="column.size"
                                [style.width.px]="column.size"
                                class="sticky"
                                [class.last-sticky]="last"
                                (contextmenu)="copyTextIntoClipboard($event)">
                                @if (column.type === PropertyType.Workflow) {
                                    <app-table-workflow-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [isWorkflowStepDateVisible]="isWorkflowStepDateVisible"
                                        [row]="row"></app-table-workflow-cell>
                                } @else {
                                    <app-table-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [row]="row"
                                        [isExpanded]="row.expanded"
                                        [isExpandCommentsMode]="expandComments === true"
                                        (expandOrCollapseRow)="expandOrCollapseRow($event)"></app-table-cell>
                                }
                            </td>
                        </ng-container>
                    }
                    @for (column of scrollableColumnsDefinition; track column.propertyCode; let i = $index) {
                        <ng-container [matColumnDef]="column.propertyCode">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                [style.width.px]="column.size"
                                appColumnResize
                                (resizing)="onColumnResizing(column, $event)"
                                (resized)="onColumnResized(column)">
                                <span class="header-text" mat-sort-header [disabled]="column.type === PropertyType.Workflow" [title]="column.header">{{ column.header }}</span>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let row"
                                [style.min-width.px]="column.size"
                                [style.max-width.px]="column.size"
                                [style.width.px]="column.size"
                                (contextmenu)="copyTextIntoClipboard($event)">
                                @if (column.type === PropertyType.Workflow) {
                                    <app-table-workflow-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [isWorkflowStepDateVisible]="isWorkflowStepDateVisible"
                                        [row]="row"></app-table-workflow-cell>
                                } @else {
                                    <app-table-cell
                                        class="resultTable-cell"
                                        [column]="column"
                                        [row]="row"
                                        [isExpanded]="row.expanded"
                                        [isExpandCommentsMode]="expandComments === true"
                                        (expandOrCollapseRow)="expandOrCollapseRow($event)"></app-table-cell>
                                }
                            </td>
                        </ng-container>
                    }
                    <ng-container [matColumnDef]="actionColumnDefinition.propertyCode" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef [style.min-width.px]="60" [style.max-width.px]="60" [style.width.px]="60" class="action-header sticky">
                            <div class="action-header-text">{{ actionColumnDefinition.header }}</div>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let row; let index = dataIndex"
                            class="action-column"
                            [style.min-width.px]="60"
                            [style.max-width.px]="60"
                            [style.width.px]="60"
                            class="action-cell sticky">
                            <app-table-action-cell
                                [actionColumnDefinition]="actionColumnDefinition"
                                [row]="row"
                                [view]="viewsStateService.getSelectedView()"
                                [index]="index"
                                (contextualMenuOpen)="onContextualMenuOpen($event)"
                                (contextualMenuSelect)="onContextualMenuSelect($event)"></app-table-action-cell>
                        </td>
                    </ng-container>
                }
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnCodes.length">
                        @if (expandComments === true) {
                            <app-expanded-comment-cell [viewType]="viewType" [row]="element" [isExpanded]="element.expanded"></app-expanded-comment-cell>
                        } @else {
                            <app-expanded-detail-cell [row]="element" [isExpanded]="element.expanded"></app-expanded-detail-cell>
                        }
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnCodes; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnCodes; let index = dataIndex"
                    [class.hidden]="(dragContext.draggingRef && isSelected(index)) || isDropped(index)"
                    class="element-row"
                    [class.expanded-row]="row.expanded"
                    [class.dragging]="dragContext.isDragging"
                    [class.selected]="isSelected(index)"
                    [class.double-height]="isWorkflowStepDateVisible"
                    (click)="onMouseClick($event, index)"
                    (dblclick)="onMouseDoubleClick($event, index)"
                    cdkDrag
                    [cdkDragDisabled]="!mergeFoldersRight && !moveFolderToBoxRight"
                    (cdkDragStarted)="onDragStarted($event, row, index)"
                    (cdkDragEnded)="onDragEnded($event, row)"
                    [ngClass]="{ 'in-standby': row.isInStandByState, 'archiving-state': row.isInWaitingArchivingState }">
                    <div class="drop-custom-placeholder" *cdkDragPlaceholder></div>
                    <div *cdkDragPreview>
                        <app-dragged-row-preview [draggedElementsCount]="selectionContext.selections.length || 1" [dragContext]="dragContext"></app-dragged-row-preview>
                    </div>
                </tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: ['expandedDetail']"
                    class="detail-row"
                    [ngClass]="{ 'detail-row-expanded': row.expanded, 'detail-row-collapsed': !row.expanded }"></tr>
            </table>
        </form>
    }

    @if (loadedFoldersCount === 0) {
        <div class="no-folder-container mat-table">
            <p>Aucun dossier existant.</p>
        </div>
    }
</div>
